import { render, staticRenderFns } from "./detailreportError.vue?vue&type=template&id=76181410&scoped=true&"
import script from "./detailreportError.vue?vue&type=script&lang=js&"
export * from "./detailreportError.vue?vue&type=script&lang=js&"
import style0 from "./detailreportError.vue?vue&type=style&index=0&id=76181410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76181410",
  null
  
)

export default component.exports